const initialState = {
  isOpen: true,
};

const changeSideBarReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case "CHANGE_SIDEBAR":
      return {
        ...state,
        isOpen: payload,
      };
    default:
      return {
        ...state,
      };
  }
};

export default changeSideBarReducer;
